/**
 * components/tableElements/ConfirmModal.jsx
 * Simple confirm dialog rendered inline via portal when open.
 */

import { __ } from "@wordpress/i18n";
import { createPortal } from "@wordpress/element";

export default function ConfirmModal({
    open,
    title,
    description,
    confirmText,
    danger = false,
    onConfirm,
    onCancel,
}) {
    if (!open) return null;

    const portal = document.getElementById("wpbean-pgs-settings-app");

    const modal = (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center p-4"
            style={{ background: "rgba(0,0,0,0.4)" }}
            onClick={onCancel}
        >
            <div
                className="bg-white rounded-lg shadow-xl w-full max-w-sm p-6"
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
            >
                <h3 className="text-base font-semibold text-gray-900 mb-2">
                    {title}
                </h3>
                <p className="text-sm text-gray-500 mb-6">{description}</p>
                <div className="flex justify-end gap-3">
                    <button
                        onClick={onCancel}
                        className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                    >
                        {__("Cancel", "wpbean-product-gallery-slider-for-woocommerce")}
                    </button>
                    <button
                        onClick={onConfirm}
                        className={`px-4 py-2 text-sm font-medium text-white rounded-lg transition-colors ${
                            danger
                                ? "bg-red-600 hover:bg-red-700"
                                : "bg-blue-600 hover:bg-blue-700"
                        }`}
                    >
                        {confirmText || __("Confirm", "wpbean-product-gallery-slider-for-woocommerce")}
                    </button>
                </div>
            </div>
        </div>
    );

    return portal ? createPortal(modal, portal) : modal;
}
